import { Layout } from 'antd';
import ErrorBoundary from 'components/ErrorBoundary';
import React from 'react';

const Content = ({ children, ...rest }) => (
  <Layout.Content {...rest}>
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  </Layout.Content>
);

export default Content;
